import { Link } from 'react-router-dom';

const benefits = [
  {
    title: 'Examen realista',
    body: 'Cronometro estable, navegacion clara, tipos de pregunta identicos al oficial. Sin sorpresas el dia D.',
    icon: '🕒',
  },
  {
    title: 'Reportes que ensenan',
    body: 'Mapa de calor por dominio, brechas concretas, plan de estudio en 3-5 acciones. No solo un numero.',
    icon: '📊',
  },
  {
    title: 'Contenido original',
    body: 'Preguntas creadas desde objetivos oficiales y revisadas manualmente. Cero dumps. Legalmente defendible.',
    icon: '🛡️',
  },
];

const featuredCerts = [
  { code: 'AZ-104', vendor: 'Azure', title: 'Azure Administrator', level: 'Associate' },
  { code: 'AZ-305', vendor: 'Azure', title: 'Azure Solutions Architect Expert', level: 'Expert' },
  { code: 'SAA-C03', vendor: 'AWS', title: 'AWS Solutions Architect Associate', level: 'Associate' },
];

export function Landing() {
  return (
    <>
      {/* HERO */}
      <section className="relative isolate overflow-hidden">
        <div className="absolute inset-x-0 top-0 -z-10 h-[600px] bg-gradient-to-br from-sky-500/10 via-transparent to-violet-500/10" aria-hidden="true" />
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
          <div className="mx-auto max-w-3xl text-center">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl lg:text-6xl">
              Simula tu certificacion cloud
              <br />
              <span className="bg-gradient-to-r from-sky-500 to-violet-500 bg-clip-text text-transparent">
                con la sensacion del examen real.
              </span>
            </h1>
            <p className="mt-6 text-lg text-text-secondary sm:text-xl">
              Reportes profundos por dominio. Plan de estudio accionable. En espanol, para
              profesionales TI de LATAM y Espana.
            </p>
            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link to="/registro" className="btn-primary text-base">
                Probar gratis 20 preguntas
              </Link>
              <Link to="/precios" className="btn-secondary text-base">
                Ver planes
              </Link>
            </div>
            <p className="mt-4 text-xs text-text-tertiary">
              Sin tarjeta. Cancela cuando quieras. Reembolso 48h.
            </p>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-6 md:grid-cols-3">
            {benefits.map((b) => (
              <div key={b.title} className="card">
                <div className="text-3xl" aria-hidden="true">
                  {b.icon}
                </div>
                <h3 className="mt-4 text-lg font-semibold">{b.title}</h3>
                <p className="mt-2 text-sm text-text-secondary">{b.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURED CERTS */}
      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">Certificaciones disponibles</h2>
            <p className="mt-3 text-text-secondary">Compromiso de lanzamiento — 6 certificaciones de alta demanda.</p>
          </div>

          <div className="mt-10 grid gap-4 md:grid-cols-3">
            {featuredCerts.map((c) => (
              <Link
                key={c.code}
                to={`/certificaciones/${c.code}`}
                className="group card transition-all hover:-translate-y-0.5 hover:border-accent-primary hover:shadow-md"
              >
                <div className="flex items-baseline justify-between">
                  <span className="text-xs font-mono text-accent-primary">{c.vendor}</span>
                  <span className="text-xs text-text-tertiary">{c.level}</span>
                </div>
                <h3 className="mt-2 text-xl font-bold">{c.code}</h3>
                <p className="mt-1 text-sm text-text-secondary">{c.title}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-accent-primary group-hover:gap-2 transition-all">
                  Ver detalle
                  <span aria-hidden="true">→</span>
                </span>
              </Link>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link to="/certificaciones" className="btn-secondary">
              Ver todas las certificaciones
            </Link>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-20 sm:py-24">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="card border-accent-primary/30 bg-gradient-to-br from-sky-500/5 to-violet-500/5 text-center">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
              Empieza tu preparacion hoy
            </h2>
            <p className="mt-4 text-text-secondary">
              20 preguntas gratis por certificacion. Sin tarjeta.
              <br />
              Cuando estes listo, USD 12.90/mes te da el banco completo.
            </p>
            <div className="mt-8">
              <Link to="/registro" className="btn-primary text-base">
                Crear cuenta gratis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
